module.exports = __webpack_public_path__ + "static/media/logo-white.5cc7b6e5.webp";